import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { dashboardOverviewQueryKey, fetchDashboardOverview } from '#/api/dashboard';

/**
 * 主控台資料（狀態卡＋月別圖＋金額圓餅）。`range` 為 null 時後端各 module 用 Asia/Taipei 當月。
 * @param {{ from: string, to: string } | null} range
 * @param {{ currencyId?: string, trendMonths?: number, enabled?: boolean }} [options]
 */
export function useDashboardOverview(range, { currencyId, trendMonths, enabled = true } = {}) {
  return useQuery({
    queryKey: dashboardOverviewQueryKey(range, currencyId, trendMonths),
    queryFn: () => fetchDashboardOverview(range, { currencyId, trendMonths }),
    select: (response) => response.data?.modules ?? {},
    placeholderData: keepPreviousData,
    enabled,
  });
}
